var BaseRowView = require('../baseRowView/view'),
    RowWithPageLinkMixin = require('./rowWithPageLinkMixin');

/* I'm hating the nested hierarchy ... ! */

module.exports = BaseRowView.extend({

    ROW_TYPE_CLASS_NAME: 'fr-hit-row-view-page',

    initialize: function( options ) {

        BaseRowView.prototype.initialize.apply( this, arguments );
        RowWithPageLinkMixin.setUpCurrentPageChangeListener.apply( this, arguments );

    },

    // TODO: prob best to set on model ... model hier refactor
    isCurrentPage: function() {
        return this.model.get('isCurrentPage');
    },

    // TODO: prob best to set on model
    getPageId: function() {

        return this.model.get('pageId');
    },

    serializeData: function() {

        var baseCxt = BaseRowView.prototype.serializeData.apply( this, arguments );

        return _.extend( baseCxt, {
            isPageRow: true,
            pageNumber: this.model.get('pageNumber') // could just have this in the base context ....
        }) ;

    },

    onRender: function() {

        BaseRowView.prototype.onRender.apply( this, arguments );

        this.toggleIsCurrentPage();

    },


    ui: _.extend( {}, BaseRowView.prototype.ui, RowWithPageLinkMixin.ui ),

    events:  _.extend( {}, BaseRowView.prototype.events, RowWithPageLinkMixin.events ),

    pageLinkClick: RowWithPageLinkMixin.pageLinkClick,

    toggleIsCurrentPage: RowWithPageLinkMixin.toggleIsCurrentPage



});




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/resultsView/hitsTableView/bodyRows/pageRow/view.js
 ** module id = 630
 ** module chunks = 0
 **/